<template>
	<div
		v-if="newsletters.length > 0"
		class="newsletter-container"
		@mouseenter="stopNewsletters"
		@mouseleave="startNewslettersShuffle"
		@click="openUrl()"
	>
		<transition>
			<div :key="activeNewsletter" class="newsletter-data-container">
				<div class="newsletter-header">
					<div
						:class="[
							'newsletter-type',
							{'drc-topic' : newsletters[activeNewsletter].platform === PLATFORMS.DRC},
							{'gop-topic' : newsletters[activeNewsletter].platform === PLATFORMS.GOP}
							]"
					>
						{{ newsletters[activeNewsletter].topic }}
					</div>
					<div :class="[
						'newsletter-category',
						{'drc-title' : newsletters[activeNewsletter].platform === PLATFORMS.DRC},
						{'gop-title' : newsletters[activeNewsletter].platform === PLATFORMS.GOP}
						]"
					>
						{{ newsletters[activeNewsletter].title }}
					</div>
				</div>
				<div class="newsletter-content">
					<div class="newsletter-title">{{ newsMessageSize > newsletters[activeNewsletter].message.length ? newsletters[activeNewsletter].message : newsletters[activeNewsletter].message.slice(0, newsMessageSize) + '...'  }}</div>
				</div>
				<button v-if="!isMobileDevice">
					{{ newsletters[activeNewsletter].redirectionButtonText }}
				</button>
			</div>
		</transition>
	</div>
</template>
<script>
import * as GRAPHQL_SERVICE from "@/common/services/common-graphql-service";
import {PLATFORMS} from "@/common/utils/constants";

export default {
	name: 'Newsletter',
	data() {
		return {
			windowWidth: window.innerWidth,
			activeNewsletter: 0,
			shuffle: null,
			newsletters: [],
			PLATFORMS: PLATFORMS,
			newsMessageSize: 100
		}
	},
	mounted() {
		this.fetchActiveNewsletters();
		this.calculateTitleSize();
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	computed: {
		isMobileDevice() {
			return window.innerWidth < 1024;
		}
	},
	methods: {
		onResize() {
			this.windowWidth = window.innerWidth
			this.calculateTitleSize();
		},
		calculateTitleSize(){
			this.newsMessageSize = (this.windowWidth / 5) / (window.innerHeight / 800);
		},
		fetchActiveNewsletters() {
			GRAPHQL_SERVICE.fetchActiveNewsLetters()
				.then((response) => {
					this.newsletters = response;
					this.startNewslettersShuffle();
				})
				.catch((error) => console.error(error))
		},
		openUrl() {
			window.open(this.newsletters[this.activeNewsletter].redirectUrl, '_blank');
		},
		startNewslettersShuffle() {
			this.shuffle = setInterval(() => {
				this.activeNewsletter = this.activeNewsletter > this.newsletters.length - 2 ? 0 : this.activeNewsletter + 1;
			}, 6000);
		},
		stopNewsletters() {
			clearInterval(this.shuffle);
		}
	}
}
</script>
<style scoped lang="scss">
@import "@/common/assets/css/_variables.scss";

.newsletter-container {
	font-family: Roboto, serif;
	position: absolute;
	bottom: 2vh;
	left: 5%;
	width: 90%;
	//height: 10 dvh;
	height: 6 dvh;
	max-height: 10vh;
	background: $newsletter-container-background;
	padding: 2vh;
	backdrop-filter: blur(1vh);
	border-radius: 4px;
	overflow: hidden;
	transition: all 0.1s ease-in-out;
	z-index: 1;
	cursor: pointer;

	&:hover {
		background: $newsletter-hover-background;
	}

	.v-enter-active,
	.v-leave-active {
		transition: all 0.2s ease-in-out;
	}

	.v-enter-to,
	.v-leave-to {
		top: -6vh !important;
		//top: -10vh !important;
	}

	.newsletter-data-container {
		position: relative;
		overflow: hidden;
		height: 7vh;
		//height: 10vh;
		top: 0;
	}

	.newsletter-content {
		display: flex;
	}

	button {
		width: 8vw;
		min-width: 150px;
		height: 5vh;
		border: 1px solid $newsletter-button-text;
		background: none;
		position: absolute;
		right: 2vw;
		top: 0.5vh;
		font-family: Roboto, serif;
		font-size: 1.5vh;
		font-weight: 600;
		line-height: 3vh;
		color: $color-white-light;
		white-space: nowrap;
		cursor: pointer;
	}

	.newsletter-header {
		display: flex;
		gap: 1vw;
		margin-bottom: 0.5vh;
		font-size: 1.5vh;
		font-weight: 400;
		line-height: 2vh;
		letter-spacing: 0;

		.newsletter-type {
			color: $newsletter-type-color;
			padding: 0 5px;
			border-radius: 2px;
			text-transform: capitalize;
		}

		.drc-topic {
			background: $color-hover-button;
		}

		.gop-topic {
			background: $gop-blue;
		}

		.drc-title {
			color: $color-hover-button;
		}

		.gop-title {
			color: $gop-blue;
		}

	}

	.newsletter-title {
		font-size: 2vh;
		font-weight: 400;
		line-height: 2vh;
		letter-spacing: 0.38px;
		max-width: 85%;
		height: 4vh;
		overflow: hidden;
	}

	.newsletter-text {
		font-size: 2vh;
		font-weight: 400;
		line-height: 3vh;
		letter-spacing: 0;
		color: $landing-text-color;
	}
}

@media screen and (max-width: $size-screen-tablet-max) {
	.newsletter-container {
		width: 100%;
		bottom: 0;
		left: 0;
		padding: 2vh;
		border-radius: 0;

		.newsletter-title {
			line-height: 2vh;
		}
	}
}
</style>
